var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-filter", class: _vm.isDialog ? "dialog" : null },
    [
      _vm.filter
        ? _c("save-filter-dialog", {
            ref: "save-filter-dialog",
            on: {
              save: function ($event) {
                return _vm.$parent.$emit("save")
              },
            },
            model: {
              value: _vm.filter,
              callback: function ($$v) {
                _vm.filter = $$v
              },
              expression: "filter",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.filter
        ? _c("delete-filter-confirm-dialog", {
            ref: "delete-filter-confirm-dialog",
            on: {
              delete: function ($event) {
                return _vm.$parent.$emit("delete", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.savedFilters
        ? _c(
            "div",
            { staticClass: "tabs" },
            _vm._l(_vm.modes, function (item) {
              return _c("div", { staticClass: "tab" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.mode,
                      expression: "mode",
                    },
                  ],
                  attrs: {
                    type: "radio",
                    id: `${_vm._uid}-filter-mode-${item.value}`,
                    name: `${_vm._uid}-modes`,
                  },
                  domProps: {
                    value: item.value,
                    checked: _vm._q(_vm.mode, item.value),
                  },
                  on: {
                    change: function ($event) {
                      _vm.mode = item.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { attrs: { for: `${_vm._uid}-filter-mode-${item.value}` } },
                  [_vm._v(_vm._s(item.name))]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.mode === "app-filter"
        ? _c("div", [
            _c(
              "div",
              { staticClass: "filter-mode-wrapper standard-form-style" },
              [
                _c(
                  "fieldset",
                  { staticClass: "filter-fieldset open no-toggle" },
                  [
                    _c("legend", { attrs: { tabindex: "0" } }, [
                      _vm._v("Date"),
                    ]),
                    _vm._v(" "),
                    _c("DateRangeOptions", {
                      attrs: {
                        options: _vm.dateOptions,
                        limits: { min: null, max: null },
                      },
                      on: { input: _vm.onDateRangeInput },
                      model: {
                        value: _vm.date,
                        callback: function ($$v) {
                          _vm.date = $$v
                        },
                        expression: "date",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._t("default"),
                _vm._v(" "),
                !_vm.isDialog
                  ? _c("div", { staticClass: "actions" }, [
                      _c(
                        "a",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.clearFilter(true)
                            },
                          },
                        },
                        [_vm._v("Clear Filter")]
                      ),
                      _vm._v(" "),
                      _vm.savedFilters
                        ? _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  _vm.$refs["save-filter-dialog"].show = true
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.t("app-save-filter")))]
                          )
                        : _vm._e(),
                    ])
                  : _c("div", { staticClass: "actions dialog-actions" }, [
                      _c("div", { staticClass: "left-side" }, [
                        _c("a", { on: { click: _vm.clearFilterInDialog } }, [
                          _vm._v("Clear Filter"),
                        ]),
                        _vm._v(" "),
                        _vm.savedFilters
                          ? _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.$parent.$parent.$emit(
                                      "show-save-dialog"
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.t("app-save-filter")))]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "right-side" }, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.$parent.$parent.$emit("hide-dialog")
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.t("app-close")))]
                        ),
                      ]),
                    ]),
              ],
              2
            ),
          ])
        : _c(
            "div",
            { staticClass: "saved-filters-mode-wrapper" },
            _vm._l(_vm.savedFilters.collection, function (filter) {
              return _c("div", [
                _c("div", { staticClass: "saved-filter" }, [
                  _c(
                    "a",
                    {
                      staticClass: "select-saved-filter",
                      on: {
                        click: function ($event) {
                          return _vm.loadSavedFilter(filter)
                        },
                      },
                    },
                    [_vm._v(_vm._s(filter.attributes.title))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "delete-saved-filter",
                      on: {
                        click: function ($event) {
                          return _vm.showDeleteConfirmationDialog(filter)
                        },
                      },
                    },
                    [
                      _c("span", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              height: "24px",
                              viewBox: "0 0 24 24",
                              width: "24px",
                            },
                          },
                          [
                            _c("path", {
                              attrs: { d: "M0 0h24v24H0z", fill: "none" },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ])
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }